module.exports = __webpack_public_path__ + "static/img/propic-line.822294e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/drawing/propic-line.png
// module id = EjA0
// module chunks = 1